import { faArrowLeft, faFileExport, faPlus } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { IPermissionConfig } from "../config/interfaces";
import FASvgIcon from "./FASvgIcon";
import GuardedComponent from "./GuardedComponent";

type Props = {
  backIconButton?: boolean;
  onBackPress?: () => void;
  title: string | JSX.Element;
  titleClass?: any;
  titleId?: string;
  outlineBtnTitle?: string;
  onExportBtnPress?: any;
  outlineBtnRules?: IPermissionConfig | undefined;
  dropDownBtnTitle?: string;
  dropDownBtnEvents?: any[];
  primaryBtnTitle?: string;
  onPrimaryBtnPress?: any;
  primaryBtnRules?: IPermissionConfig | null;
  filtersForm?: any;
  isDisable?: boolean;
};

const PageHeader: React.FC<Props> = (props: Props) => {
  const {
    backIconButton,
    onBackPress,
    title,
    titleClass,
    titleId,
    outlineBtnTitle,
    onExportBtnPress,
    outlineBtnRules = undefined,
    dropDownBtnTitle,
    dropDownBtnEvents,
    primaryBtnTitle,
    onPrimaryBtnPress,
    primaryBtnRules = null,
    filtersForm,
    isDisable
  } = props;

  const navigate = useNavigate();

  const showDropDown = useMemo(() => {
    if (!dropDownBtnEvents) {
      return false;
    }

    let _ddEvents: IPermissionConfig[] = [];
    dropDownBtnEvents?.forEach((d) => {
      if (d.actionRules) {
        _ddEvents.push(...d.actionRules.permissions);
      }
    });
  }, [dropDownBtnEvents?.length]);

  return (
    <>
      <div className="title-wrap">
        <div className={classNames("title-wrap--heading", !backIconButton && "parent-page-title")}>
          {backIconButton && (
            <Button
              variant="transparent"
              className="icon-only"
              onClick={() => {
                onBackPress ? onBackPress() : navigate(-1);
              }}
            >
              <FASvgIcon icon={faArrowLeft} />
            </Button>
          )}
          <h1 className={classNames(titleClass)}>
            {title}
            {titleId && (
              <>
                : <span className="title-bold-wrap">{titleId}</span>
              </>
            )}
          </h1>
          {filtersForm ? filtersForm : null}
        </div>

        {onPrimaryBtnPress || onExportBtnPress ? (
          <div className="title-wrap--btns">
            {onExportBtnPress ? (
              <Button
                size="lg"
                variant="outline-secondary"
                title="Export List"
                className="btn-w-50 p-0 bg-transparent"
                onClick={() => (onExportBtnPress ? onExportBtnPress() : null)}
              >
                <FASvgIcon icon={faFileExport} />
              </Button>
            ) : null}

            <GuardedComponent rules={primaryBtnRules} behavior="hide">
              <Button
                size="lg"
                variant="primary"
                className="btn-w-160"
                onClick={() => (onPrimaryBtnPress ? onPrimaryBtnPress() : null)}
                disabled={isDisable}
              >
                <FASvgIcon icon={faPlus} />
                {primaryBtnTitle}
              </Button>
            </GuardedComponent>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default PageHeader;
